export const gallerySectiongeneralContracting =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        {
            "src": "/assets/imgs/services/0007GeneralContracting/1.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0007GeneralContracting/2.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0007GeneralContracting/3.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0007GeneralContracting/4.jpg",
            "rowSpan": 1,
            "colSpan": 1
        }
    ]

}